var _excluded = ["children", "className", "onBackClick", "backLinkContent"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import Link from "@components/link";
import Icon from "@components/icon";
import { joinCn } from "@ati/uti";
import styles from "../Popup.module.scss";
var Header = _ref => {
  var {
      children,
      className,
      onBackClick,
      backLinkContent
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: joinCn(styles["popup-header"], className)
  }, rest), !!backLinkContent && /*#__PURE__*/React.createElement("div", {
    className: styles["back-link-block"]
  }, /*#__PURE__*/React.createElement(Link, {
    className: styles["back-link"],
    onClick: onBackClick,
    before: /*#__PURE__*/React.createElement(Icon, {
      name: "ic_arrow-left-bold",
      width: 9,
      height: 13
    }),
    size: "large",
    theme: "gray"
  }, backLinkContent)), /*#__PURE__*/React.createElement("h1", {
    className: styles["popup-header-title"]
  }, children));
};
export default Header;